import React from 'react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
export function Settings() {
  return <div className="space-y-6 max-w-4xl" data-id="element-254">
      <div data-id="element-255">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-256">সিস্টেম সেটিংস</h1>
        <p className="text-slate-500" data-id="element-257">
          সাধারণ কনফিগারেশন এবং পেমেন্ট গেটওয়ে সেটিংস
        </p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-258">
        <div className="p-6 border-b border-slate-100" data-id="element-259">
          <h2 className="text-lg font-bold text-slate-900" data-id="element-260">সাধারণ সেটিংস</h2>
        </div>
        <div className="p-6 space-y-6" data-id="element-261">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-262">
            <div className="space-y-2" data-id="element-263">
              <label className="text-sm font-medium text-slate-700" data-id="element-264">
                সাইটের নাম
              </label>
              <Input defaultValue="চিম্বুক পাহাড় টিকিটিং সিস্টেম" data-id="element-265" />
            </div>
            <div className="space-y-2" data-id="element-266">
              <label className="text-sm font-medium text-slate-700" data-id="element-267">
                প্রতিষ্ঠানের নাম
              </label>
              <Input defaultValue="জেলা প্রশাসন, বান্দরবন পার্বত্য জেলা" data-id="element-268" />
            </div>
            <div className="space-y-2 md:col-span-2" data-id="element-269">
              <label className="text-sm font-medium text-slate-700" data-id="element-270">
                কিওস্ক ওয়েলকাম মেসেজ
              </label>
              <Input defaultValue="চিম্বুক পাহাড়ে স্বাগতম" data-id="element-271" />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-272">
        <div className="p-6 border-b border-slate-100" data-id="element-273">
          <h2 className="text-lg font-bold text-slate-900" data-id="element-274">প্রিন্টার সেটিংস</h2>
        </div>
        <div className="p-6 space-y-6" data-id="element-275">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-276">
            <div className="space-y-2" data-id="element-277">
              <label className="text-sm font-medium text-slate-700" data-id="element-278">
                প্রিন্টারের নাম
              </label>
              <Input defaultValue="KIOSK-THERMAL-PRINTER-01" data-id="element-279" />
            </div>
            <div className="space-y-2" data-id="element-280">
              <label className="text-sm font-medium text-slate-700" data-id="element-281">
                স্ট্যাটাস
              </label>
              <div className="flex items-center h-12 px-3 text-sm font-medium text-brand-green bg-brand-green/10 rounded-xl" data-id="element-282">
                Connected
              </div>
            </div>
            <div className="space-y-2" data-id="element-283">
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-284">
                <input type="checkbox" defaultChecked className="w-4 h-4 text-brand-coral rounded border-slate-300 focus:ring-brand-coral" data-id="element-285" />
                <span className="text-sm font-medium text-slate-700" data-id="element-286">
                  স্বয়ংক্রিয়ভাবে টিকিট প্রিন্ট করুন (Auto Print)
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-287">
        <div className="p-6 border-b border-slate-100" data-id="element-288">
          <h2 className="text-lg font-bold text-slate-900" data-id="element-289">
            পেমেন্ট গেটওয়ে কনফিগারেশন
          </h2>
        </div>
        <div className="p-6 space-y-6" data-id="element-290">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-291">
            <div className="space-y-2" data-id="element-292">
              <label className="text-sm font-medium text-slate-700" data-id="element-293">
                bKash Merchant ID
              </label>
              <Input defaultValue="BKASH-MERCHANT-CHIMBUK" type="password" data-id="element-294" />
            </div>
            <div className="space-y-2" data-id="element-295">
              <label className="text-sm font-medium text-slate-700" data-id="element-296">
                Nagad Merchant ID
              </label>
              <Input defaultValue="NAGAD-MERCHANT-CHIMBUK" type="password" data-id="element-297" />
            </div>
            <div className="space-y-2" data-id="element-298">
              <label className="text-sm font-medium text-slate-700" data-id="element-299">
                Payment Mode
              </label>
              <select className="flex h-12 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-coral" data-id="element-300">
                <option data-id="element-301">Live</option>
                <option data-id="element-302">Sandbox (Test)</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-end" data-id="element-303">
        <Button size="lg" data-id="element-304">সেটিংস সংরক্ষণ করুন</Button>
      </div>
    </div>;
}